<mat-toolbar color="primary">
  <span>Weather Forecast</span>
  <span class="spacer"></span>
  <button mat-icon-button (click)="sidenav.controller.close()">
    <mat-icon>close</mat-icon>
</button>
</mat-toolbar>

<div class="content">
  <h3>
    Select a city
  </h3>
  
  <app-dropdown
    label="Weather"
    [optionsArray]="list"
    [control]="control"
    key="place"
    panelClass="panel-weather"
  ></app-dropdown>
  
  <div class="weather">
    <app-progress-spinner
      color="accent"
      [style.display]="loading ? 'block' : 'none'"
    ></app-progress-spinner>
  
    <div 
      #container
      [style.display]="loading ? 'none' : 'block'"
    >
      <a
        #provider
        class="weatherwidget-io"
        data-label_2="WEATHER" 
        data-font="Roboto" 
        data-icons="Climacons Animated" 
        data-theme="original" 
        data-basecolor="#001c43" 
        data-highcolor="#f7db88" 
        data-lowcolor="#00bedd" 
        data-suncolor="#eeb711" 
        data-cloudfill="#464e5f" 
        data-raincolor="#00bedd"
      ></a>
    </div>
  </div>
</div>